module.exports = __webpack_public_path__ + "img/flag-ES.7c83e9c1.svg";